import { render } from "./alerts.vue?vue&type=template&id=3284706c"
import script from "./alerts.vue?vue&type=script&lang=ts"
export * from "./alerts.vue?vue&type=script&lang=ts"

import "./alerts.vue?vue&type=style&index=0&id=3284706c&lang=scss"
script.render = render

export default script